import { render, staticRenderFns } from "./InterimBill.vue?vue&type=template&id=5ce495fd&"
import script from "./InterimBill.vue?vue&type=script&lang=js&"
export * from "./InterimBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports